// extracted by mini-css-extract-plugin
export default {"root":"Ftmenu_root__1Jsxf","center":"Ftmenu_center__PM9WD","menu":"Ftmenu_menu__XSHhT","icon":"Ftmenu_icon__4-LU+","unnamed":"Ftmenu_unnamed__ZjYaB"};